/**
 * Sticky preferences for the landing page. All client-side localStorage —
 * no PII, no tracking, just enough state to make returning visits feel like
 * the app remembers you.
 *
 *  - last_provider:    "discord" | "google"        (which OAuth used last)
 *  - last_name:        first name for "WELCOME BACK, KEVIN"
 *  - last_league_slug: jump back to most-recent league
 *  - last_game:        preferred game filter on /leagues
 */
const KEY = "lhub_prefs";

export function readPrefs() {
  try { return JSON.parse(localStorage.getItem(KEY) || "{}"); }
  catch { return {}; }
}

export function writePrefs(patch) {
  try {
    const cur = readPrefs();
    const next = { ...cur, ...patch };
    localStorage.setItem(KEY, JSON.stringify(next));
    return next;
  } catch { return patch; }
}

export function clearPrefs() {
  try { localStorage.removeItem(KEY); } catch { /* ignore */ }
}
